import script from "./TeamsView.vue?vue&type=script&setup=true&lang=js"
export * from "./TeamsView.vue?vue&type=script&setup=true&lang=js"

import "./TeamsView.vue?vue&type=style&index=0&id=05c1f499&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-05c1f499"]])

export default __exports__